import script from "./BaseTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTabs.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTabs.vue?vue&type=style&index=0&id=1fe957f3&lang=scss"

const __exports__ = script;

export default __exports__